import { render, staticRenderFns } from "./NumproCate.vue?vue&type=template&id=fbc25af0&"
import script from "./NumproCate.vue?vue&type=script&lang=js&"
export * from "./NumproCate.vue?vue&type=script&lang=js&"
import style0 from "./NumproCate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports